import React, { useState, useEffect } from 'react';
import Highcharts from 'highcharts';
import HighchartsReact from 'highcharts-react-official';
import './ProjectImpactOverview.scss';

// Import and initialize 3D module
import 'highcharts/highcharts-3d';

const ProjectImpactOverview = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      const element = document.getElementById('project-impact-section');
      if (element) {
        const rect = element.getBoundingClientRect();
        const windowHeight = window.innerHeight;
        
        // Check if section is 50% visible
        if (rect.top < windowHeight * 0.5 && rect.bottom > windowHeight * 0.5) {
          setIsVisible(true);
        } else if (rect.bottom < -100 || rect.top > windowHeight + 100) {
          // Reset when section is completely out of view
          setIsVisible(false);
        }
      }
    };

    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  const chartOptions = {
    chart: {
      height: 420,
      type: 'pie',
      options3d: {
        enabled: true,
        alpha: 45,
        beta: 0,
      },
      backgroundColor: 'transparent',
      spacing: [20, 20, 20, 20]
    },
    title: {
      text: null
    },
    plotOptions: {
      pie: {
        size: '160%',
        allowPointSelect: false,
        cursor: 'pointer',
        depth: 65,
        innerSize: 0,
        dataLabels: {
          enabled: true,
          format: '{point.y}',
          distance: 0,
          connectorWidth: 0,
          style: {
            color: 'white',
            fontWeight: 'bold',
            fontSize: '20px',
            textOutline: 'none'
          }
        },
        showInLegend: true
      }
    },
    series: [{
      name: 'Impact',
      colorByPoint: true,
      data: [
        {
          name: 'Household Light',
          y: 35,
          color: '#3d9b35'
        },
        {
          name: 'Productive Use',
          y: 25,
          color: '#d4c62f'
        },
        {
          name: 'Community Services',
          y: 15,
          color: '#f5b932'
        },
        {
          name: 'Cooking Solutions',
          y: 15,
          color: '#3ac7e0'
        },
        {
          name: 'Industrial Use',
          y: 10,
          color: '#f3b494'
        }
      ]
    }],
    legend: {
      enabled: true,
      align: 'center',
      verticalAlign: 'bottom',
      layout: 'horizontal',
      itemStyle: {
        fontSize: '12px',
        color: '#333'
      },
      symbolHeight: 12,
      symbolWidth: 12,
      symbolRadius: 6,
      margin: 45,               
      itemMarginTop: 10,
      itemMarginBottom: 0,      
    },
    credits: {
      enabled: false
    }
  };

  return (
    <section id="project-impact-section" className={`project-impact-section ${isVisible ? 'animate' : ''}`}>
      <div className="container">
        <div className="project-impact-content">
          {/* Left Column - Text and Stats */}
          <div className="project-impact-left">
            <h2 className="section-title">Project Impact Overview</h2>
            <p className="section-subtitle">
              Understanding how energy investments are changing lives across Africa
            </p>
            
            <div className="stats-grid">
              <div className="stat-card">
                <div className="stat-label">Household Electrified</div>
                <div className="stat-number">4.5M</div>
              </div>
              <div className="stat-card">
                <div className="stat-label">CO₂ Reduction</div>
                <div className="stat-number">3.2M tons</div>
              </div>
              <div className="stat-card">
                <div className="stat-label">Jobs created</div>
                <div className="stat-number">125.0K</div>
              </div>
              <div className="stat-card">
                <div className="stat-label">Countries impacted</div>
                <div className="stat-number">28</div>
              </div>
            </div>
          </div>

          {/* Right Column - 3D Pie Chart */}
          <div className="project-impact-right">
            <div className="chart-container">
              <HighchartsReact
                highcharts={Highcharts}
                options={chartOptions}
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ProjectImpactOverview;



